export default {"src":"/_next/static/media/configuration-and-deployment.4fd2f5a6.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};